module.exports = __webpack_public_path__ + "img/IMG-20200827-WA0000.686d286a.jpg";